module.exports = __webpack_public_path__ + "/assets/img/adfddaa9fcf07df60c35d0c4dae58f07.svg";